import React from 'react';
import { CButton, CSpinner } from '@coreui/react';
import useKeycloak from '../../utils/keycloak.init';

const Landing = () => {
    const [authError, setAuthError] = React.useState(null);
    const keycloak = useKeycloak({ onError: setAuthError });

    const signOut = () => {
        localStorage.clear();
        keycloak.logout({ redirectUri: window.location.origin + '/admin/' });
    };

    return (
        <div className="hsnc-auth-screen">
            <div className="hsnc-auth-card">
                {!authError ? (
                    <>
                        <CSpinner component="span" size="lg" aria-hidden="true" style={{ color: '#123F2C' }} />
                        <h3 style={{ marginTop: 16 }}>Signing you in</h3>
                        <p style={{ color: '#5A6360', fontSize: 13 }}>Checking your university account…</p>
                    </>
                ) : (
                    <>
                        <h3>Couldn't verify your access</h3>
                        <p style={{ color: '#5A6360', fontSize: 13, lineHeight: 1.55 }}>
                            Your account isn't linked to a role in this portal.
                            Sign out and back in, or contact the university admin.
                        </p>
                        <CButton color="primary" onClick={signOut}>Sign out</CButton>
                    </>
                )}
            </div>
        </div>
    );
}

export default Landing;
